export default __webpack_public_path__ + "static/media/ContestAmount.5c349f32.svg";